<template>
  <b-row no-gutter class="forms-date-time-picker">
    <b-col col lg="12">
      <forms-date-picker
        :disabled="disabled"
        :disabled-dates="disabledDates"
        :disabled-dates-fct="disabledDatesFct"
        :value="dateValue"
        @input="emitChangeDate"
      />
    </b-col>

    <b-col col lg="12">
      <time-selector
        :disabled="disabled"
        :disabled-times-fct="disabledTimesFct"
        :minute-interval="15"
        :value="timeValue"
        @input="emitChangeTime"
      />
    </b-col>
  </b-row>
</template>

<script>
import FormsDatePicker from "@/components/Forms/DatePicker.vue";
import TimeSelector from "@/components/Forms/TimeSelector.vue";

export default {
  name: "FormsDateTimePicker",
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabledDates: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
    disabledDatesFct: {
      type: Function,
      required: false,
      default: () => false,
    },
    disabledTimesFct: {
      type: Function,
      required: false,
      default: () => false,
    },
    value: {
      type: String,
      required: true,
    },
  },
  components: {
    FormsDatePicker,
    TimeSelector,
  },
  computed: {
    dateValue() {
      return this.parts[0];
    },
    timeValue() {
      return this.$dayjs(this.value).toDate();
    },
    parts() {
      return this.value.split(" ");
    },
  },
  methods: {
    emitChangeDate(value) {
      this.$emit("input", `${value} ${this.parts[1]}`);
    },
    emitChangeTime(value) {
      const newTime = this.$dayjs(value).format("HH:mm");
      this.$emit("input", `${this.parts[0]} ${newTime}:00`);
    },
  },
};
</script>

<style lang="scss">
.forms-date-time-picker {
  .forms-datepicker {
    margin-bottom: 10px;
  }

  .vtimeselector__clear {
    display: none;
  }
}
</style>
